// src/Pages/Landing/JoyrideVantaaLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideVantaaLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Vantaa"
      maakunta="Uusimaa"
      nearbyAreas={[
        "Helsinki",
        "Espoo",
        "Kerava",
        "Järvenpää",
        "Tuusula",
        "Sipoo"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Vantaalla tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Vantaa sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja yksityistilaisuuksiin, kun juhliin halutaan energinen livebändi."
      logisticsText="Bilebändi Joyride tulee Keski-Uudeltamaalta, joten Vantaa on bändille erittäin luontevaa lähialuetta. Oma kuljetus, oma äänentoisto ja valotekniikka helpottavat kokonaisuuden suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}